import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { DroppableSeatContainer } from './droppableSeatContainer';
export const DroppableSeatsContainer = () => {
    const seatedPlayerSeatIndexes = useAppSelector((state) => state.poker.seatedPlayerSeatIndexes, shallowEqual);
    return (_jsx(_Fragment, { children: seatedPlayerSeatIndexes.map((seatIndex) => (_jsx(DroppableSeatContainer, { seatIndex: seatIndex }, seatIndex))) }));
};
